<template src="./ratings-breakdown.html"></template>

<script lang="ts">
import { localizedThousandsInteger } from 'util/localization-utils'
const MIN_REVIEWS_FOR_FILTERING = 3

export default {
  props: {
    disableFiltering: { type: Boolean, default: true },
    headingLevel: { type: Number, default: 3 },
    ratingsBreakdown: {
      type: Array,
      default: () => []
    }
  },
  emits: ['setFilter'],
  computed: {
    breakdownForDisplay() {
      // slice used to make a copy of array to sort so prop is not manipulated
      return this.ratingsBreakdown.slice(0).sort((a, b) => b.rating - a.rating)
        .map((item) => {
          const percentage = (item.num / this.total)
          // only going to apply a filter if this item has reviews and the overall total is
          // at least 3
          const isFilterable = !this.disableFiltering && this.total >= MIN_REVIEWS_FOR_FILTERING &&
            item.num > 0
          return {
            isFilterable,
            num: item.num,
            progressWidth: `${(percentage * 100).toFixed(1)}%`,
            pctOfRatingsFormatted: item.pctOfRatingsFormatted,
            rating: item.rating
          }
        })
    },
    formattedTotal() {
      return localizedThousandsInteger(this.total)
    },
    total() {
      return this.ratingsBreakdown.reduce((acc, curr) => acc + curr.num, 0)
    }
  },
  methods: {
    ratingSelected(ratingData) {
      if (!ratingData || !ratingData.isFilterable) {
        return
      }
      this.$emit('setFilter', 'cm', 'rt', ratingData.rating)
    }
  }
}
</script>

<style lang="scss" src="./ratings-breakdown.scss"></style>
